import script from "./DeleteProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteProfile.vue?vue&type=script&setup=true&lang=js"

import "./DeleteProfile.vue?vue&type=style&index=0&id=3604f816&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3604f816"]])

export default __exports__